import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Ability } from '@casl/ability';
import { Actions, PermissionObjectType, Subjects } from '../../helpers';
import { COMPANY_ITEMS } from '../../constants';

interface Iprops {
  setCloseSettingsPanel: any;
  ability?: Ability<[Actions, Subjects], PermissionObjectType>;
}

const CompanyMenu = (props: Iprops): React.ReactElement => {
  const { t } = useTranslation();
  const { setCloseSettingsPanel, ability } = props;

  return (
    <div className=" pb-2.5 px-3 flex flex-col gap-3">
      {COMPANY_ITEMS.map((item) =>
        !ability ||
        ability.can(item?.action || 'update', item.name as Subjects) ? (
          <Link
            className="block h-10 px-3 py-2 text-base hover:rounded-lg hover:bg-blue-95 text-neutral-10"
            to={{ pathname: item.path }}
            onClick={() => setCloseSettingsPanel(false)}
            key={item.code}
          >
            <div className="flex items-center">
              {item.icon && (
                <div className="mr-4 text-blue-00">
                  <item.icon />
                </div>
              )}
              {t(`sidebar.links.${item.code}`)}
            </div>
          </Link>
        ) : null,
      )}
    </div>
  );
};

export default CompanyMenu;
